const REFUND_STATUSES = {
  FAILED: 'failed',
  SUCCEEDED: 'succeeded',
  PENDING: 'pending'
}

export { REFUND_STATUSES }
